export default "__VITE_ASSET__0f577015__"